import(/* webpackMode: "eager" */ "/builds/eva-kita/typo3/next/lib/components/ui/Headline.tsx");
import(/* webpackMode: "eager" */ "/builds/eva-kita/typo3/next/lib/components/ui/Subheader.tsx");
import(/* webpackMode: "eager" */ "/builds/eva-kita/typo3/next/lib/components/ui/Section.tsx");
import(/* webpackMode: "eager" */ "/builds/eva-kita/typo3/next/lib/components/document/partials/Layout.tsx")